/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import PageType from 'linced-app/enums/page-type';

export default class InfoSection extends Component {
  @action
  setNavCardOpen(value) {
    this.navCardOpen = value;
  }

  PageType = PageType;
  @tracked
  navCardOpen = false;
}
